export const generalData: any = (origin: string, image: string) => {
  return `
  {
    "@context": "http://schema.org",
    "@type": "Hotel",
    "name": "Boutique hotel 43",
    "url": "${origin}",
    "logo": "${origin}/icons/icon-512x512.png",
    "image": "${origin}${image}",
    "description": "Boutique hotel Nr.43, Stationsstraat 43 1541 LG Koog aan de Zaan, Amsterdam, Zaanse Schans",
    "priceRange": "€127 - €216",
    "sameAs": "https://www.instagram.com/boutiquehotel43/?hl=en",
    "telephone": "0621438097",
    "email": "info@boutiquehotel43.com",
    "checkinTime": "1970-01-01T15:00+0100",
    "checkoutTime": "1970-01-01T10:00+0100",
    "address" :  {
      "@type" : "PostalAddress",
      "streetAddress": "Stationsstraat 43",
      "addressLocality": "Koog aan de Zaan",
      "addressRegion": "Noord-Holland",
      "postalCode": "1541LG",
      "addressCountry": "Netherlands"
    },
    "geo":{
      "@type":"GeoCoordinates",
      "latitude":"52.46953201293945",
      "longitude":"4.80879020690918"
    },
    "hasMap": "https://www.google.com/maps/place/52.46953201293945,4.80879020690918",
    "availableLanguage": ["English", "Dutch"],
    "petsAllowed": "False",
    "smokingAllowed": "False",
    "starRating": {
      "@type": "Rating",
      "ratingValue": "5"
    },
    "amenityFeature": [
      {
        "@type":"LocationFeatureSpecification",
        "name":"Free Wi-Fi"
      },
      {
        "@type":"LocationFeatureSpecification",
        "name":"Free parking"
      },
      {
        "@type":"LocationFeatureSpecification",
        "name":"Accessible"
      },
      {
        "@type":"LocationFeatureSpecification",
        "name":"Air-conditioned"
      },
      {
        "@type":"LocationFeatureSpecification",
        "name":"Kid-friendly"
      },
      {
        "@type":"LocationFeatureSpecification",
        "name":"Restaurant"
      },
      {
        "@type":"LocationFeatureSpecification",
        "name":"Smoke-free
        "}
    ]
  }
`
};

export const roomData: any = (origin: string, href: string, image: string, description: string, bed: string, occupancy: string, amenityFeature: any) => {
  return `{
    "@context": "http://schema.org",
    "@type": "HotelRoom",
    "name": "Deluxe Rooms",
    "url": "${href}",
    "image": "${origin}${image}",
    "description": "${description}",
    "containedInPlace":{
      "@type":"Place",
      "name": "Boutique hotel 43",
      "url": "${origin}",
      "hasMap":"https://www.google.com/maps/place/52.46953201293945,4.80879020690918",
      "address" :  {
        "@type" : "PostalAddress",
        "streetAddress": "Stationsstraat 43",
        "addressLocality": "Koog aan de Zaan",
        "addressRegion": "Noord-Holland",
        "postalCode": "1541LG",
        "addressCountry": "Netherlands"
      },
      "geo":{
        "@type":"GeoCoordinates",
        "latitude":"52.46953201293945",
        "longitude":"4.80879020690918"
      },
      "bed": {
        "@type" : "BedDetails",
        "numberOfBeds": ${bed}
      },
      "occupancy": {
        "@type" : "QuantitativeValue",
        "maxValue" : ${JSON.stringify(occupancy)}
      },
      "amenityFeature": ${JSON.stringify(amenityFeature)}
    }
  }`
};
